import DesktopIcon from "@mui/icons-material/DesktopWindowsRounded";
import type { ButtonProps, SxProps, Theme } from "@mui/material";
import { Button, Link } from "@mui/material";
import type { AccessPermission } from "@entrilia/shared/api/types";
import TooltipForDisabledAction from "@entrilia/shared/components/TooltipForDisabledAction";
import useMergedSx from "@entrilia/shared/hooks/useMergedSx";
import useClientContext from "../../../context/useClientContext";
import type { ImpersonationNavigationParams } from "../../../utilities/navigationHelper";
import { getInvestorPortalImpersonationUrl } from "../../../utilities/navigationHelper";

interface Props {
  params?: ImpersonationNavigationParams;
  variant?: ButtonProps["variant"];
  color?: ButtonProps["color"];
  disabled?: boolean;
  disabledTooltipText?: string;
  sx?: SxProps<Theme>;
}

const InvestorPortalImpersonateButton = ({ params, variant, color, disabled, disabledTooltipText, sx }: Props) => {
  const { clientCode, hasAnyPermission } = useClientContext();

  const buttonSx = useMergedSx({ whiteSpace: "nowrap" }, sx);

  const investorPortalUrl = getInvestorPortalImpersonationUrl(clientCode, params ?? { target: "Investor" });

  const targetPermission: AccessPermission =
    params?.target === "DataCollection"
      ? "ViewInvestorPortalOnBehalfOfPortfolioCompany"
      : "ViewInvestorPortalOnBehalfOfInvestor";

  const isVisible = hasAnyPermission([targetPermission]);

  if (!isVisible) {
    return null;
  }

  return (
    <TooltipForDisabledAction title={disabled ? disabledTooltipText : undefined} isActionDisabled={disabled}>
      <Button
        component={Link}
        variant={variant}
        color={color}
        disabled={disabled}
        href={investorPortalUrl}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={variant !== "text" && <DesktopIcon />}
        sx={buttonSx}
      >
        Impersonate
      </Button>
    </TooltipForDisabledAction>
  );
};

export default InvestorPortalImpersonateButton;
